var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative"},[_c('div',{staticClass:"absolute bottom-0 left-0 mb-75"},[_c('div',{attrs:{"id":"auto-scroll-block"}})])])}]

export { render, staticRenderFns }